module.exports = __webpack_public_path__ + "static/media/player2.ab0f7331.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/games/coinRunner/player2.png
// module id = 997
// module chunks = 0